


import {Component, Vue, Watch} from "vue-property-decorator";
import {SelectListItem} from "@/core/common-type-definitions";
import api from '@/api'
import {SplitOrderCycleSettingInput, SplitOrderCycleType} from "@/api/appService";

@Component({
  name: 'CycleSetting',
  filters: {
    formatCycleValue(value: number): string {

      switch (value) {
        case 1:
          return '周一'
        case 2:
          return '周二'
        case 3:
          return '周三'
        case 4:
          return '周四'
        case 5:
          return '周五'
        case 6:
          return '周六'
        case 0:
          return '周日'
        default:
          return ''
      }
    }
  }
})
export default class CycleSetting extends Vue {


  loading = true;
  saving = false;

  cycleTypes: SelectListItem<string>[] = [
    {value: 'Daily', label: '每天'},
    {value: 'Weekly', label: '每周'},
    {value: 'Monthly', label: '按月'},
    {value: 'Period', label: '固定天数间隔'}
  ]

  monthDays: SelectListItem<number>[] = []

  selectedCycleType: SplitOrderCycleType = SplitOrderCycleType.Period

  currentDetailValue: number | undefined = 1;

  details: number[] = []

  created() {
    for (let i = 1; i <= 28; i++) {
      this.monthDays.push({
        label: i.toString(),
        value: i
      });
    }
    this.loading = true;
    api.configuration.getSplitOrderCycleSetting().then((response) => {
      this.selectedCycleType = response?.cycleType ?? SplitOrderCycleType.Period

      this.details = (response?.values ?? '15').split(',').map(i=>parseInt(i))
      this.loading = false
    })
  }


  addItem() {
    if (this.details.some(item => item === this.currentDetailValue)) {
      this.$message.error('不能重复添加')
    } else {
      this.details.push(this.currentDetailValue!);
    }
  }

  removeItem(index: number) {
    this.details.splice(index,1);
  }

  get hasDetails(): boolean {
    return this.details && this.details.length > 0;
  }

  onSelectedCycleTypeChange(newValue: SplitOrderCycleType) {
    this.details = []
    if (newValue === SplitOrderCycleType.Period) {
      this.details = [15];
    } else if (newValue === SplitOrderCycleType.Monthly || newValue === SplitOrderCycleType.Weekly) {
      this.currentDetailValue = 1;
    } else {
      this.currentDetailValue = undefined
    }

  }


  updateValue() {
    this.saving = true;
    const requestBody = {
      cycleType: this.selectedCycleType,
      values: this.details.join(',')
    } as SplitOrderCycleSettingInput
    api.configuration.updateSplitOrderCycleSetting({body: requestBody}).then(() => {
      this.$message.success('分账周期配置完成')
      this.saving = false
    }).catch(() => {
      this.saving = false
    })
  }

}

